import React, { forwardRef } from "react";
import cn from "helpers/classnames";
import Loader from "./Loader";

const LoadingPill = forwardRef(({ className }, ref) => {
  return (
    <div
      className={cn(
        "tw-flex tw-gap-2 tw-items-center tw-py-1.5 tw-px-3",
        "tw-bg-purple-tint-95 tw-leading-4.5 tw-rounded-2xl",
        className
      )}
      ref={ref}
    >
      <Loader className="tw-w-3 tw-h-3 tw-border-solid tw-border-[1.5px] tw-border-purple" />
      <span className="tw-text-gray-tint-10 tw-font-semibold subtitle-2">
        Loading messages
      </span>
    </div>
  );
});

export default LoadingPill;
